import { NOTIFICATION_CATEGORIES } from "../../../enums/notificationCategories.enum";
import { ParseNotificationError } from "../../../services/api/notifications-api/notifications-api.service";

export interface NotificationChannelSetting {
  category: NOTIFICATION_CATEGORIES;
  app: boolean;
  email: boolean;
}

export const notificationPermissionCategoryMapping: Record<string, NOTIFICATION_CATEGORIES> = {
  repairRequest: NOTIFICATION_CATEGORIES.REPAIR_REQUEST,
  intServiceContract: NOTIFICATION_CATEGORIES.INT_SERVICE_CONTRACT,
  extServiceContract: NOTIFICATION_CATEGORIES.EXT_SERVICE_CONTRACT,
  predictiveService: NOTIFICATION_CATEGORIES.PREDICTIVE_SERVICE,
  energyLoss: NOTIFICATION_CATEGORIES.ENERGY_LOSS,
  faultReporting: NOTIFICATION_CATEGORIES.FAULT_REPORTING,
};

const notificationSettingCategories = new Set<string>(Object.values(NOTIFICATION_CATEGORIES));

export const isNotificationSettingCategory = (value: string): value is NOTIFICATION_CATEGORIES =>
  notificationSettingCategories.has(value);

export const parseNotificationChannelSettings = (value: unknown): NotificationChannelSetting[] => {
  if (!Array.isArray(value)) {
    throw new ParseNotificationError("Notification settings response must be an array");
  }

  const categories = new Set<NOTIFICATION_CATEGORIES>();
  const settings: NotificationChannelSetting[] = [];

  for (const item of value) {
    if (!item || typeof item !== "object" || Array.isArray(item)) {
      throw new ParseNotificationError("Notification setting must be an object");
    }

    const { category, app, email } = item as Record<string, unknown>;
    if (typeof category !== "string") {
      throw new ParseNotificationError("Notification setting category must be a string");
    }

    if (!isNotificationSettingCategory(category)) {
      continue;
    }
    if (typeof app !== "boolean" || typeof email !== "boolean") {
      throw new ParseNotificationError(`Notification setting for ${category} has invalid channels`);
    }
    if (categories.has(category)) {
      throw new ParseNotificationError(`Notification settings contain duplicate category ${category}`);
    }

    categories.add(category);
    settings.push({ category, app, email });
  }

  return settings;
};
